import { GetSymbolsReturn } from '@web/walter-lib/api'

export const getSymbolCode = (currencyCode: string, symbols: GetSymbolsReturn | undefined) => {
    if (!symbols) {
        return
    }

    const usdtPair = `${currencyCode.toUpperCase()}USDT`
    const btcPair = `${currencyCode.toUpperCase()}BTC`
    const reverseUsdtPair = `USDT${currencyCode.toUpperCase()}`
    const reverseBtcPair = `BTC${currencyCode.toUpperCase()}`

    let symbolCode
    let isReverseSymbol
    let convertibleCurrency

    if (symbols[usdtPair]) {
        symbolCode = usdtPair
        isReverseSymbol = false
        convertibleCurrency = 'USDT'
    } else if (symbols[reverseUsdtPair]) {
        symbolCode = reverseUsdtPair
        isReverseSymbol = true
        convertibleCurrency = 'USDT'
    } else if (symbols[btcPair]) {
        symbolCode = btcPair
        isReverseSymbol = false
        convertibleCurrency = 'BTC'
    } else if (symbols[reverseBtcPair]) {
        symbolCode = reverseBtcPair
        isReverseSymbol = true
        convertibleCurrency = 'BTC'
    }

    return { isReverseSymbol, convertibleCurrency, symbolCode }
}
